module.exports = __webpack_public_path__ + "static/media/layout-3.61b9ce60.svg";